export const pet_categories = [
  { id: 1, name: "Dog", value: "dog" },
  { id: 2, name: "Cat", value: "cat" },
  { id: 3, name: "Bird", value: "bird" },
];

export const service_locations = [
  { id: 1, name: "Arlington", value: "arlington" },
  { id: 2, name: "Houston", value: "houston" },
  { id: 3, name: "Dallas", value: "dallas" },
  { id: 4, name: "Austin", value: "austin" },
];

const item_categories = [
  { id: 1, name: "Toys", value: "toys" },
  { id: 2, name: "Food", value: "food" },
  { id: 3, name: "Apparel", value: "apparel" },
];

export default item_categories;
